module.exports = __webpack_public_path__ + "static/media/pagseguro.611a5572.png";